<template>
    <div class="edit-forms" v-if="!hideDetails">
        <img src="@/assets/imgs/logo-white.svg" class="d-block mx-auto logo pt-4" />
        <div id="edit-user-data" class="bg-white radius-top-30 mt-3 text-secondary mx-auto overflow-hidden mb-4" style="max-width: 550px !important;">
            <div class="d-flex justify-content-center align-items-center"> 
                <form id="data-form" @submit.prevent="saveData" class="">
                <div class="row" id="step1" v-show="!steps" style="max-width: 550px!important">
                    <div class="col-md-12">
                        <h2 class="text-center">Cuenta Bancaria</h2>
                    </div>
                    <div class="col-md-6">
                        <label>País de la Cuenta</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userCountryBank" v-model="userCountryBank" @change="findCurrency(); userCurrencyBank = ''" disabled autocomplete="new-userCountryBank">
                            </select>    
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Moneda</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userCurrencyBank" disabled v-model="userCurrencyBank" @change="findBanksNames(); userBankName = ''" autocomplete="new-userCurrencyBank">
                            </select>    
                        </div>
                    </div>
                    <div :class="colAjust">
                        <label>Banco / Billetera Digital</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userBankName" v-model="userBankName" autocomplete="new-userBankName">
                            </select>    
                        </div>
                    </div>
                    <div class="col-md-6" v-show="colTipoCuenta == true">
                        <label>Tipo de Cuenta:</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userTypeBank" v-model="userTypeBank" v-if="this.userCountryBank == 89" autocomplete="new-userTypeBank">
                                <option value="">Seleccionar</option>
                                <option value="C">Cuenta Corriente (C)</option>
                                <option value="S">Cuenta de Ahorro (S)</option>
                                <option value="M">Cuenta Maestra (M)</option>
                            </select>    
                            <select class="form-control form-control-lg text-center" attr-id="userTypeBank" v-model="userTypeBank" v-if="this.userCountryBank == 82" autocomplete="new-userTypeBank">
                                <option value="">Seleccionar</option>
                                <option value="C">Cuenta Corriente (C)</option>
                                <option value="S">Cuenta de Ahorro (S)</option>   
                            </select>    
                            <select class="form-control form-control-lg text-center" attr-id="userTypeBank" v-model="userTypeBank" v-if="this.userCountryBank == 81" autocomplete="new-userTypeBank">
                                <option value="">Seleccionar</option>
                                <option value="C">Cuenta Corriente (C)</option>
                                <option value="S">Cuenta de Ahorro (S)</option>
                                <option value="V">Cuenta Vista (V)</option>
                            </select>    
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>{{ cbuText }}</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center" attr-id="userCbuBank" v-model="userCbuBank" autocomplete="new-userCbuBank">
                        </div>
                    </div>

                    <div class="col-md-12">
                        <label>Alias:</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center text-uppercase" attr-id="userAliasBank" v-model="userAliasBank" autocomplete="new-userAliasBank"> 
                        </div>
                    </div>

                    <div class="col-md-12">
                        <h4 class="text-center">Datos del Titular</h4>
                    </div>
                    <div class="col-md-12">
                        <label>Nombre:</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center" attr-id="userFirstName" v-model="userFirstName" autocomplete="new-userFirstName">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>Apellido:</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center" attr-id="userLastName" v-model="userLastName" autocomplete="new-userLastName"> 
                        </div>
                    </div>
                    <div class="mb-3 d-grid gap-2 col-12 mx-auto mt-5">
                        <button class="btn btn-primary" type="submit" :disabled="disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Guardar</button>
                        <button class="btn btn-secondary" type="button" @click="this.$router.go(-1)">Volver</button>
                    </div> 
                </div>
            </form>
            <div id="step2" v-show="steps" class="change-info-form text-center">
                <div class="container justify-content-md-center"> 
                    <img src="@/assets/imgs/check-blue.webp" class="w-25" />
                    <h4 class="fs-4 fw-400">Tus datos bancarios fueron modificados.</h4>   
                    <div class="mb-3 d-grid gap-2 col-12 mx-auto mt-5">
                        <button class="btn btn-primary tourReady" type="button" @click="this.$router.go(-1); this.$root.finishTour();">Listo</button>
                    </div>
                </div>
            </div> 
            </div>
        </div>
        
    </div>


    <div>
       
            
   
        <div id="edit-user-bank" v-show="hideDetails" class="mt-3 text-secondary mb-4 overflow-hidden" :class="classHideDetails">
            <form id="data-form">
                <div class="row p-0 m-0" id="step1" v-show="!steps" style="max-width: 100% !important">
                    <div class="col-md-6">
                        <label>País de la Cuenta</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userCountryBank" v-model="userCountryBank" @change="findCurrency(); userCurrencyBank = ''" disabled autocomplete="new-userCountryBank">
                            </select>    
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>Moneda</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userCurrencyBank" disabled v-model="userCurrencyBank" @change="findBanksNames(); userBankName = ''" autocomplete="new-userCurrencyBank">
                            </select>    
                        </div>
                    </div>
                    <div :class="colAjust">
                        <label>Banco</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userBankName" v-model="userBankName" @change="sendDataChange()" autocomplete="new-userBankName">
                            </select>    
                        </div>
                    </div>
                    <div class="col-md-6" v-show="colTipoCuenta == true">
                        <label>Tipo de Cuenta:</label>    
                        <div class="input-group mb-3">
                            <select class="form-control form-control-lg text-center" attr-id="userTypeBank" @change="sendDataChange()" v-model="userTypeBank" v-if="this.userCountryBank == 89" autocomplete="new-userTypeBank">
                                <option value="">Seleccionar</option>
                                <option value="C">Cuenta Corriente (C)</option>
                                <option value="S">Cuenta de Ahorro (S)</option>
                                <option value="M">Cuenta Maestra (M)</option>
                            </select>    
                            <select class="form-control form-control-lg text-center" attr-id="userTypeBank" @change="sendDataChange()" v-model="userTypeBank" v-if="this.userCountryBank == 82" autocomplete="new-userTypeBank">
                                <option value="">Seleccionar</option>
                                <option value="C">Cuenta Corriente (C)</option>
                                <option value="S">Cuenta de Ahorro (S)</option>   
                            </select>    
                            <select class="form-control form-control-lg text-center" attr-id="userTypeBank" @change="sendDataChange()" v-model="userTypeBank" v-if="this.userCountryBank == 81" autocomplete="new-userTypeBank">
                                <option value="">Seleccionar</option>
                                <option value="C">Cuenta Corriente (C)</option>
                                <option value="S">Cuenta de Ahorro (S)</option>
                                <option value="V">Cuenta Vista (V)</option>
                            </select>    
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>{{ cbuText }}</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center" @keyup="sendDataChange()" attr-id="userCbuBank" v-model="userCbuBank" autocomplete="new-userCbuBank">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>Alias:</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center text-uppercase" @keyup="sendDataChange()" attr-id="userAliasBank" v-model="userAliasBank" autocomplete="new-userAliasBank"> 
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>Nombre:</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center" @keyup="sendDataChange()" attr-id="userFirstName" v-model="userFirstName" autocomplete="new-userFirstName">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>Apellido:</label>    
                        <div class="input-group mb-3">
                            <input type="text" class="form-control form-control-lg text-center" @keyup="sendDataChange()" attr-id="userLastName" v-model="userLastName" autocomplete="new-userLastName"> 
                        </div>
                    </div>  
                </div>
            </form>
        </div>

            
        <div class="position-fixed bottom-0 end-0 start-0 p-3" style="z-index: 11; width: fit-content;">
            <div id="toastcontainer" class="w-25">
            </div>
        </div>
    </div>
</template>

<script>
//import api from '@/api.js'
import axios from "axios";
import { Toast } from 'bootstrap'

export default { 
    props: ['hideDetails'],
    name: "email",
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            userCountryBank: '',
            userCurrencyBank: '',
            userBankName: '',
            userTypeBank: '',
            userCbuBank: '',
            userAliasBank: '',
            colAjust: '',
            cbuText: '',
            colTipoCuenta: '',
            userFirstName: '',
            userLastName: '',
            errorScreen: '',
            dataReceiver: '',
            loading: false,
            disabled: false,
            steps: false,
            classHideDetails: '',
            bankAdded: 'no'
        }
    },
    mounted: function () {
        if(this.hideDetails == true){
            this.classHideDetails ="text-secondary";
        }
        document.querySelector('html').style.overflow = "auto";

        if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
            this.dataReceiver = localStorage.getItem('corporativeIn');
        }else{
            this.dataReceiver = localStorage.getItem('token');
        }
        this.findUserInfo();      
    }, 
    methods:{ 
        async findUserInfo(){
            var payload = {
                action: 'find-user-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver    
            }
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                    var data = result.data;
                    this.userCountryBank = data.userCountry;
                    this.findUserCountry();     
                 }  
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.toastColor = 'bg-danger';
                    this.errorText = 'Revise su conexión de internet.';
                    var toast = new Toast(this.$refs.el)
                    toast.show()	
                    return;
                })
        },     
        async findUserCountry(){
            if(this.userCountryBank == ''){
                this.errorScreen = 'Debes primero configurar tu domicilio.';
                return;
            }
            if(this.userCountryBank == 5 || this.userCountryBank == 89 || this.userCountryBank == 82 || this.userCountryBank == 111 || this.userCountryBank == 12 ||  this.userCountryBank == 42 || this.userCountryBank == 81 || this.userCountryBank == 28 || this.userCountryBank == 103){
                var payload = {
                    action: 'find-countries',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host      
                }
                await axios.post('/index.php', payload)
                .then(result => {
                    try{        
                        document.querySelector("[attr-id='userCountryBank']").innerHTML = '';
                        var option = document.createElement("option");
                        option.value = '';
                        option.text = 'Seleccionar';
                        option.defaultSelected = true;              
                        document.querySelector("[attr-id='userCountryBank']").add(option);
                        let sum = 0;
                        Object.keys(result.data).forEach(key => {
                            var option = document.createElement("option");
                            option.value = result.data[sum].id;
                            option.text = result.data[sum].name;  
                            if(this.userCountryBank == 5 || this.userCountryBank == 89 || this.userCountryBank == 82 || this.userCountryBank == 111 || this.userCountryBank == 12 || this.userCountryBank == 42 || this.userCountryBank == 81 || this.userCountryBank == 28 || this.userCountryBank == 103){ 
                                if(this.userCountryBank == result.data[sum].id){
                                    option.defaultSelected = true;
                                    document.querySelector("[attr-id='userCountryBank']").add(option);
                                }else{
                                    document.querySelector("[attr-id='userCountryBank']").add(option);
                                }   
                            }      
                            sum++;
                        }); 
                    }catch(e){
                        
                    }
                    if(this.userCountryBank == 5){
                        this.cbuText = 'CBU ó CVU Nº';
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }else if(this.userCountryBank == 42){
                        this.cbuText = 'Cuenta Nº';
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }else if(this.userCountryBank == 81){
                        this.cbuText = 'Cuenta Nº';
                        this.colTipoCuenta = true;
                        this.colAjust = 'col-md-6';
                    }else if(this.userCountryBank == 28){
                        this.cbuText = 'IBAN';
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }else if(this.userCountryBank == 89){
                        this.cbuText = 'C.I:';
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }else if(this.userCountryBank == 82){
                        this.cbuText = 'Cuenta Número:';
                        this.colTipoCuenta = true;
                        this.colAjust = 'col-md-6';
                    }else if(this.userCountryBank == 111){
                        this.cbuText = 'Cuenta Número:'; 
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }else if(this.userCountryBank == 12){
                        this.cbuText = 'Chave Pix';
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }else if(this.userCountryBank == 103){
                        this.cbuText = 'Cuenta Número:';
                        this.colTipoCuenta = false;
                        this.colAjust = 'col-md-12';
                    }   
                    this.findCurrency();  
                });
            }else{
                this.errorScreen = 'No puedes cargar una cuenta bancaria para tu país. Contactate con nuestro equipo para encontrar una solución.';
                return;
            }
        },
        async findCurrency(){
            var payload = {
                    action: 'find-currency',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    userCountry: this.userCountryBank,      
                } 
                await axios.post('/index.php', payload)
                .then(result => {
                    try{              
                        document.querySelector("[attr-id='userCurrencyBank']").innerHTML = '';
                        var option = document.createElement("option");
                        option.value = '';
                        option.text = 'Seleccionar';
                        option.defaultSelected = true;              
                        document.querySelector("[attr-id='userCurrencyBank']").add(option);
                        let sum = 0;
                        Object.keys(result.data).forEach(key => {
                            var option = document.createElement("option");
                            option.value = result.data[sum].id;
                            option.text = result.data[sum].name; 
                            this.userCurrencyBank =  option.value;       
                            if(this.userCountryBank == 5 || this.userCountryBank == 89 || this.userCountryBank == 82 || this.userCountryBank == 111 || this.userCountryBank == 12 || this.userCountryBank == 42 || this.userCountryBank == 81 || this.userCountryBank == 28 || this.userCountryBank == 103){                           
                                option.defaultSelected = true;
                                document.querySelector("[attr-id='userCurrencyBank']").add(option);   
                            }      
                            sum++;
                        });
                    }catch(e){
                        
                    }
                    this.sendDataChange();
                   this.findBanksNames();
                });
        },
        async findBanksNames(){
            var payload = {
                    action: 'find-banks-names',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    userCountry: this.userCountryBank,      
                } 
                await axios.post('/index.php', payload)
                .then(result => {
                    try{
                        document.querySelector("[attr-id='userBankName']").innerHTML = '';
                        var option = document.createElement("option");
                        option.value = '';
                        option.text = 'Seleccionar';
                        option.defaultSelected = true;              
                        document.querySelector("[attr-id='userBankName']").add(option);
                        let sum = 0;
                        Object.keys(result.data).forEach(key => {
                            var option = document.createElement("option");
                            option.value = result.data[sum].id;
                            option.text = result.data[sum].name;  
                            if(this.userCountryBank == 5 || this.userCountryBank == 89 || this.userCountryBank == 82 || this.userCountryBank == 111 || this.userCountryBank == 12 || this.userCountryBank == 42 || this.userCountryBank == 81 || this.userCountryBank == 28 || this.userCountryBank == 103){                           
                                if(this.userBankName == result.data[sum].id){
                                    option.defaultSelected = true;
                                    document.querySelector("[attr-id='userBankName']").add(option);
                                }else{
                                    document.querySelector("[attr-id='userBankName']").add(option);
                                }   
                            }      
                            sum++;
                        });
                    }catch(e){

                    }
                   this.findBankUserData();
                });
        },
        async findBankUserData(){
            var payload = {
                    action: 'find-user-bank',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.dataReceiver     
                } 
                await axios.post('/index.php', payload)
                .then(result => {   
                    if(result.data.status == '200'){
                        this.userBankName = result.data.bankCode;
                        this.userTypeBank = result.data.accountType;
                        this.userCbuBank = result.data.account;
                        this.userFirstName = result.data.name;
                        this.userLastName = result.data.lastname; 
                        this.userAliasBank = result.data.userAliasBank;
                        if(this.hideDetails == true){
                            this.bankAdded = this.userBankName;
                            this.sendDataChange();
                        }
                     }else if(result.data.status == '400'){
                        if(this.hideDetails == true){
                            this.bankAdded = '';
                            this.sendDataChange();
                        }
                     }    
                });
        },
        async saveData(){  
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.errorText = '';
            this.loading = true;
            this.disabled = true;
            var payload = {
                action: 'update-user-bank',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                userCountry: this.userCountryBank,
                userFirstName: this.userFirstName,
                userLastName: this.userLastName,
                userTypeBank: this.userTypeBank,
                userBankName: this.userBankName,
                userCurrencyBank: this.userCurrencyBank,
                userCBU: this.userCbuBank,
                userAliasBank: this.userAliasBank
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.loading = false;
                this.disabled = false;
                if(result.data.status == '200'){
                    var step1 = document.querySelector('#step1');
                    var step2 = document.querySelector('#step2');
                    this.$root.nextStepTour(4);
                    if(localStorage.getItem('newUser')){
                        if(localStorage.getItem('newUser') != ''){
                            if(localStorage.getItem('newUser') == '3'){
                                localStorage.setItem('newUser', 5);
                            }
                        }
                    }
                    //transicion entre pasos
                    step1.classList.add("animated", "fadeOutLeft");
                    step1.addEventListener('animationend', () => {
                        this.steps = true;
                        step1.classList.remove("animated");
                        step1.classList.remove("fadeOutLeft");
                        step1.classList.remove("fadeInRight");
                        step2.classList.add("animated", "fadeInRight");
                        step2.addEventListener('animationend', () => {    
                            step2.classList.remove("animated");
                            step2.classList.remove("fadeOutLeft");
                            step2.classList.remove("fadeInRight"); 
                            return;         
                        });     
                    }); 
                }else if(result.data.status == '400'){ 
                    if(result.data.error == 'E10'){
                        this.errorText = 'Debes ingresar el nombre del titular de la cuenta';
                        document.querySelector("[attr-id='userFirstName']").classList.add("bad");  
                        document.querySelector("[attr-id='userFirstName']").select();
                    }else if(result.data.error == 'E11'){
                        this.errorText = 'El nombre del titular de la cuenta debe estar formado por un minimo de 2 caracteres y un maxímo de 100.';
                        document.querySelector("[attr-id='userFirstName']").classList.add("bad");  
                        document.querySelector("[attr-id='userFirstName']").select();
                    }else if(result.data.error == 'E12'){
                        this.errorText = 'El nombre del titular de la cuenta no puede contener numeros ni caracteres extraños.';
                        document.querySelector("[attr-id='userFirstName']").classList.add("bad");  
                        document.querySelector("[attr-id='userFirstName']").select();
                    }else if(result.data.error == 'E13'){
                        this.errorText = 'Debes ingresar el apellido del titular de la cuenta.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");  
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E14'){
                        this.errorText = 'El apellido del titular de la cuenta debe estar formado por un minimo de 2 caracteres y un maxímo de 100.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");  
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E15'){
                        this.errorText = 'El apellido del titular de la cuenta no puede contener numeros ni caracteres extraños.';
                        document.querySelector("[attr-id='userLastName']").classList.add("bad");  
                        document.querySelector("[attr-id='userLastName']").select();
                    }else if(result.data.error == 'E20'){
                        this.errorText = 'Debes seleccionar el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCountryBank']").classList.add("bad");  
                    }else if(result.data.error == 'E21'){
                        this.errorText = 'Debes seleccionar el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCountryBank']").classList.add("bad");  
                    }else if(result.data.error == 'E22'){
                        this.errorText = 'Debes seleccionar el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCountryBank']").classList.add("bad");  
                    }else if(result.data.error == 'E30'){
                        this.errorText = 'Moneda invalida para el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCurrencyBank']").classList.add("bad");  
                    }else if(result.data.error == 'E31'){
                        this.errorText = 'Moneda invalida para el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userCurrencyBank']").classList.add("bad");  
                    }else if(result.data.error == 'E40'){
                        this.errorText = 'Banco invalido para el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userBankName']").classList.add("bad");  
                    }else if(result.data.error == 'E41'){
                        this.errorText = 'Banco invalido para el país de la cuenta bancaria.';
                        document.querySelector("[attr-id='userBankName']").classList.add("bad");  
                    }else if(result.data.error == 'E55'){
                        this.errorText = 'Debes ingresar el ' + this.cbuText;
                        document.querySelector("[attr-id='userCbuBank']").classList.add("bad");  
                        document.querySelector("[attr-id='userCbuBank']").select();
                    }else if(result.data.error == 'E56'){
                        this.errorText = 'El ' + this.cbuText + ' no es correcto.';
                        document.querySelector("[attr-id='userCbuBank']").classList.add("bad");  
                        document.querySelector("[attr-id='userCbuBank']").select();
                    }else if(result.data.error == 'E57'){
                        this.errorText = 'El ' + this.cbuText + ' no es correcto.';
                        document.querySelector("[attr-id='userCbuBank']").classList.add("bad");  
                        document.querySelector("[attr-id='userCbuBank']").select();
                    }else if(result.data.error == 'E59'){
                        this.errorText = 'Debes elegir el tipo de cuenta.';
                        document.querySelector("[attr-id='userTypeBank']").classList.add("bad");     
                    }else if(result.data.error == 'E70'){
                        this.errorText = 'El ALIAS de la cuenta debe estar formado por un minimo de 2 caracteres y un maxímo de 200.';
                        document.querySelector("[attr-id='userAliasBank']").classList.add("bad");     
                    }							
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }
                    return;
                }    
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        },

        sendDataChange(){
            if(this.hideDetails == true){ 
                this.$parent.sendDataChange(this.userCountryBank, this.userFirstName, this.userLastName, this.userTypeBank, this.userBankName, this.userCurrencyBank, this.userCbuBank, this.userAliasBank, this.cbuText, this.bankAdded)
            } 
        } 
    }  
}
</script>